import * as React from 'react';
import { View } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { rem } from 'design-system/values';
import LineChart from 'design-system/LineChart/LineChart';
import { useAppSelector } from 'store/hooks';
import { selectIsScrambled } from 'hooks/useScrambleMode';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import MinPriceIndicator from 'features/invest/components/MinPriceIndicator';
import MaxPriceIndicator from 'features/invest/components/MaxPriceIndicator';
import InitialPriceIndicator from 'features/invest/components/InitialPriceIndicator';
import AssetDebtInfoView from './overview/AssetDebtInfoView';
import { ChartType } from '../types';
import EverydayBreakdownView from './overview/EverydayBreakdownView';
import NetworthDebtBreakdownView from './overview/NetworthDebtBreakdownView';
import NetworthAssetBreakdownView from './overview/NetworthAssetBreakdownView';
const PADDING_HORIZONTAL = rem(16);
export const CHART_HEIGHT = rem(272);
const PADDING_VERTICAL = rem(34) - 10;
export const ACTUAL_CHART_HEIGHT = CHART_HEIGHT - rem(34 * 2);
const TOTAL_HORIZONTAL_PADDING = PADDING_HORIZONTAL * 2;
const AccountsLineChart = ({ title, chartType, selectedPeriod, selectedInfoObj, selectedInfoObj2, portfolioDataSet, portfolioDataSet2, }) => {
    const route = useRoute();
    const isInTab = route.name === 'NetworthTab';
    const { width } = useAppFrameDimensions(isInTab);
    const scrambled = useAppSelector(selectIsScrambled);
    const chartWidth = width - TOTAL_HORIZONTAL_PADDING;
    const points = React.useMemo(() => {
        if (portfolioDataSet[selectedPeriod]?.points?.length) {
            return portfolioDataSet[selectedPeriod].points;
        }
        return [];
    }, [portfolioDataSet, selectedPeriod]);
    const points2 = React.useMemo(() => {
        if (chartType === ChartType.assetVsDebt) {
            if (portfolioDataSet2[selectedPeriod]?.points?.length) {
                return portfolioDataSet2[selectedPeriod].points;
            }
            return [];
        }
        return undefined;
    }, [chartType, portfolioDataSet2, selectedPeriod]);
    const maxPoint = portfolioDataSet[selectedPeriod]?.maxPoint;
    const minPoint = portfolioDataSet[selectedPeriod]?.minPoint;
    const initialPoint = portfolioDataSet[selectedPeriod]?.firstItem;
    return (<View pointerEvents="box-none">
      <LineChart points={points} points2={points2} width={chartWidth} height={ACTUAL_CHART_HEIGHT} selectedInfoObj={selectedInfoObj} chartWrapperHeight={CHART_HEIGHT} selectedInfoObj2={selectedInfoObj2} paddingHorizontal={PADDING_HORIZONTAL}/>
      {!scrambled && (<>
          <InitialPriceIndicator width={chartWidth} initialPoint={initialPoint} height={ACTUAL_CHART_HEIGHT} paddingTop={PADDING_VERTICAL} selectedInfoObj={selectedInfoObj}/>
          <MaxPriceIndicator width={chartWidth} maxPoint={maxPoint} height={ACTUAL_CHART_HEIGHT} selectedInfoObj={selectedInfoObj}/>
          <MinPriceIndicator width={chartWidth} minPoint={minPoint} height={ACTUAL_CHART_HEIGHT} selectedInfoObj={selectedInfoObj}/>
          {title === 'Net Worth - Main' && (<AssetDebtInfoView width={chartWidth} selectedInfoObj={selectedInfoObj}/>)}
          {title === 'Everyday' && (<EverydayBreakdownView width={chartWidth} selectedInfoObj={selectedInfoObj}/>)}
          {title === 'Net Worth - Debt' && (<NetworthDebtBreakdownView width={chartWidth} selectedInfoObj={selectedInfoObj}/>)}
          {title === 'Net Worth - Asset' && (<NetworthAssetBreakdownView width={chartWidth} selectedInfoObj={selectedInfoObj}/>)}
        </>)}
    </View>);
};
export default React.memo(AccountsLineChart);
